<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Basic-Paragraph_para-style-override-1"><span style=" font-weight: bold; font-style: normal; font-size: 3.58em; color: #FFFFFF;">of Cape Cod</span></p>
<p class="P_Basic-Paragraph_para-style-override-1"><span style=" font-weight: bold; font-style: normal; font-size: 2.67em; color: #FFFFFF;">and the Islands</span></p>
<p class="P_Basic-Paragraph_para-style-override-3__And__Centre_Alignment"><span>Also by Barbara Sillery</span></p>
<p class="P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment"><span><span class="C_span_char-style-override-6">The Haunting of Louisiana</span><br/><span class="C_span_char-style-override-6">The Haunting of Mississippi</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?e45ccfda